import $ from "jquery"
import PageOverlayTipsManager from "../PageOverlayTipsManager"
import OverlayTips from "../OverlayTips"
import {connect} from '../../redux/utils'
import {isAnyUserListPanelOpen} from '../selectors'
import {
    areCustomersLoaded as areCustomersLoadedManagement,
    areProjectsLoaded as areProjectsLoadedManagement,
    areTasksLoaded as areTasksLoadedManagement,
    isLoaded as isEditManagementAssignmentsEditorLoaded
} from '../../administration/userManagement/managementAssignmentsEditor/selectors'
import {
    isLoaded as isWorkAssignmentsPanelLoaded,
    loadedTabs as isWorkAssignmentTabsLoaded
} from '../../administration/userManagement/workAssignmentPanel/selectors'
import {
    areCustomersLoaded as areCustomersLoadedWork,
    areProjectsLoaded as areProjectsLoadedWork,
    areTasksLoaded as areTasksLoadedWork,
    isLoaded as isWorkAssignmentsEditorLoaded
} from '../../administration/userManagement/workAssignmentsEditor/selectors'
import {isLoaded as isWorkAssignmentTabLoaded} from '../../administration/userManagement/workAssignmentsTab/selectors'
import {isLoaded as isEditManagementAssignmentsPanelLoaded} from '../../administration/userManagement/editManagementAssignmentsPanel/selectors'
import {
    getCanManageCustomerIds,
    getCanManageProjectIds,
    getCanManageTaskIds
} from '../../administration/userManagement/createUserManagementAssignmentsEditor/selectors'
import {canManagePtoAndSickDays} from '../../loggedInUser/selectors'
import {getManagementAssignmentsCounters} from '../../panels/user/userData/selectors'

class UserListPageOverlayTipsManager extends PageOverlayTipsManager {
    constructor() {
        super()

        this.state = {
            canManagePtoAndSickDays: false,
            isAnyUserListPanelOpen: false,
            isEditManagementAssignmentsEditorLoaded: false,
            isWorkAssignmentsPanelLoaded: false,
            isWorkAssignmentsEditorLoaded: false,
            isWorkAssignmentTabLoaded: false,
            isEditManagementAssignmentsPanelLoaded: false,
            areCustomersLoadedWork: false,
            areProjectsLoadedWork: false,
            areTasksLoadedWork: false,
            isWorkAssignmentTabsLoaded: false,
            areCustomersLoadedManagement: false,
            areProjectsLoadedManagement: false,
            areTasksLoadedManagement: false,
            isCreateUseManagementAssignments: false,
            canManageCustomerIds: {},
            canManageProjectIds: {},
            canManageTaskIds: {},
            managementAssignmentCounters: {},
        }

        this.onStateDeeplyChanged(() => {
            this.refreshDynamicTips()
        })

        this.onStatePropertyChanged('canManagePtoAndSickDays', () => {
            if (this.state.canManagePtoAndSickDays) {
                this._addManageBalancesTips()
            }
        })
    }

    addBaseTips() {
        super.addBaseTips()

        this._addManageAccountsTips()
        if (this.state.canManagePtoAndSickDays) {
            this._addManageBalancesTips()
        }
        this._addUserPanelTips()
        this._addWorkAssignmentsPanelTips()
        this._addManageAssignmentsPanelTips()
        this._addUserListWorkAssignmentTabTips()
        this._createUserPanelTips()
    }

    _addUserPanelTips() {
        this.add(() => $("#editUserPanel .accountInformation .passwordBlock .resetPassword:visible"),
            {
                messageKey: "tips.user_list.user_panel.password",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -30,
                offsetY: -30,
                extraClass: "aboveSlidingPanelZindex"
            }
        )
        this.add(() => $("#editUserPanel .accountInformation .passwordBlock .resendInvitation:visible"),
            {
                messageKey: "tips.user_list.user_panel.password.resent",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -30,
                offsetY: -30,
                extraClass: "aboveSlidingPanelZindex",
            }
        )
        this.add(() => $("#editUserPanel .accountInformation .hireDateValueCell"),
            {
                messageKey: "tips.user_list.user_panel.hire_date",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: 5,
                offsetY: -10,
                extraClass: "aboveSlidingPanelZindex"
            }
        )
        this.add(() => $("#editUserPanel .userPanelScopeCellContainer .blockHeader"),
            {
                messageKey: "tips.user_list.user_panel.scopes",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: 0,
                offsetY: -10,
                extraClass: "aboveSlidingPanelZindex"
            }
        )
        this.add(() => $("#editUserPanel .permissionsBlock .blockHeader"),
            {
                messageKey: "tips.user_list.user_panel.manager_permission",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -230,
                offsetY: 0,
                extraClass: "aboveSlidingPanelZindex"
            }
        )
        this.add(() => $("#editUserPanel .permissionsBlock .secondGroup"),
            {
                messageKey: "tips.user_list.user_panel.other_permission",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 15,
                offsetY: -50,
                extraClass: "aboveSlidingPanelZindex"
            }
        )
    }

    _addManageAccountsTips() {
        this.add(() => !this.state.isAnyUserListPanelOpen ? $(".showAccSettings .userListRow:not(.locked) .userNameCell").eqOrLast(0) : $(),
            {
                messageKey: "tips.user_list.user_profile",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 5,
                offsetY: -15,
                outside: {
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: -300
                }
            })

        this.add(() => $("#filterByDepartmentButton"),
            {
                messageKey: "tips.user_list.user_filter",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: 0,
                offsetY: -10,
                outside: {
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: -30
                }
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ? $("#userListTableHeader .userListHead.secondHeader .accountTab.managementHeader.teamScope") : $(),
            {
                messageKey: "tips.account_and_permissions_tab.access_to_user",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -115,
                offsetY: 0,
                wrapInner: true
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ? $("#userListTableContainer .permissionsCell .permissions .icons").eqOrLast(0) : $(),
            {
                messageKey: "tips.account_and_permissions_tab.permissions",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -80,
                offsetY: 10
            })
    }

    _addUserListWorkAssignmentTabTips() {
        this.add(() => !this.state.isAnyUserListPanelOpen ? $("#userListTabs .userManagement_tabsContainer .components_tabButton.workAssignmentTabTips:visible ") : $(),
            {
                messageKey: "tips.work_assignments.tab_title",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -65,
                offsetY: 10
            })

        this.add(
            () => !this.state.isAnyUserListPanelOpen ? $(".userListHead.firstHeader .workAssignmentsHeader.firstLayer .userList_components_itemsFilter") : $(),
            {
                messageKey: "tips.work_assignments.filter",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -20,
                offsetY: 5
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".userListHead.secondHeader .workAssignmentsHeader .workAssignmentsTab_viewerManagementCounter .tasks") : $(),
            {
                messageKey: "tips.work_assignments.viewer_assign_counters",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: 10,
                offsetY: -25
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".userList_workAssignmentsTableContainer .userListRow .workAssignmentsTab_workAssignmentsCell .tasks.active .workAssignment_counter")
                           .eqOrLast(1) : $(),
            {
                messageKey: "tips.work_assignments.team_member_assign_counters",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: 45,
                offsetY: -20
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".userList_workAssignmentsTableContainer .userListHead .controlsPlaceholder .userList_usersFilter ") : $(),
            {
                messageKey: "tips.work_assignments.user_selector",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -50,
                offsetY: 25,
                outside: {
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: -40,
                    offsetY: 10
                },
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".userList_workAssignmentsTableContainer .userListHead .controlsPlaceholder .sortLinks .sortLink").eqOrLast(0) : $(),
            {
                messageKey: "tips.work_assignments.sorted",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -30,
                offsetY: 10
            })
    }

    _addManageAssignmentsPanelTips() {
        this.add(() => $(".editManagementAssignmentsPanel .editAssignmentButton"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.ma_access_panel.edit_button",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -30,
                offsetY: 50
            })

        this.add(() => $(".editManagementAssignmentsPanel .counterTabPlaceholder .customerTab.active"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.ma_access_panel.tabs",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -90,
                offsetY: 8
            })

        this.add(() => $(".editTeamAssignmentsPanel .radioSection .noAccessSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.no_access",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -430,
                offsetY: -20
            })


        this.add(() => $(".editTeamAssignmentsPanel .radioSection .allSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.has_access_to_all_users",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -420,
                offsetY: -20
            })

        this.add(() => $(".editTeamAssignmentsPanel .radioSection .customSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.has_access_to_selected_users",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -380,
                offsetY: -20
            })

        this.add(() => $(".editUserAssignmentPanel .assignAllMenuButton.hierarchyClass_customer"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_customer_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".editUserAssignmentPanel .assignAllMenuButton.hierarchyClass_project"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_project_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".editUserAssignmentPanel .assignAllMenuButton.hierarchyClass_task"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_tasks_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".editUserAssignmentPanel .breadcrumbContainer.customer .breadcrumb .closeIcon"),
            {
                messageKey: "tips.wa_ma_panel.upper_lvl_access",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -10,
                offsetY: 7,
            })

        this.add(() => $(".editUserAssignmentPanel .entitiesList").eqOrLast(0).find(".entityListItem.hierarchyClass_customer.assigned ").eqOrLast(0),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.assign_customers_highlighted",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -400,
                offsetY: -20
            })

        this.add(() => $(".editUserAssignmentPanel .entitiesList").eqOrLast(1).find(".entityListItem.hierarchyClass_project.assigned ").eqOrLast(0),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.assign_project_highlighted",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -400,
                offsetY: -20
            })
    }

    _addWorkAssignmentsPanelTips() {
        this.add(() => $(".workAssignment_panel .workAssignments_list .noteAndRevokeButtonContainer").find(".note:not(:empty)").eqOrLast(0),
            {
                messageKey: "tips.work_assignments.wa_panel.can_manage_assign",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -40,
                offsetY: 0
            })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .assignAllMenuButton.hierarchyClass_customer"),
            {
                messageKey: "tips.work_assignments.wa_panel.assign_unassign_customers_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .assignAllMenuButton.hierarchyClass_project"),
            {
                messageKey: "tips.work_assignments.wa_panel.assign_unsign_projects_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .assignAllMenuButton.hierarchyClass_task"),
            {
                messageKey: "tips.work_assignments.wa_panel.assign_unsign_tasks_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .breadcrumbContainer.customer .breadcrumb .closeIcon"),
            {
                messageKey: "tips.wa_ma_panel.upper_lvl_access",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -10,
                offsetY: 7,
            })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .entitiesList").eqOrLast(0).find(".entityListItem.hierarchyClass_customer.assigned ")
                                                                                    .eqOrLast(0), {
            messageKey: "tips.work_assignments.wa_panel.assign_customers_highlighted",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -400,
            offsetY: -20
        })

        this.add(() => $(".userManagement_workAssignmentsEditorPanel .entitiesList").eqOrLast(1).find(".entityListItem.hierarchyClass_project.assigned ")
                                                                                    .eqOrLast(0),
            {
                messageKey: "tips.work_assignments.wa_panel.assign_projects_highlighted",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -400,
                offsetY: -20
            })
    }

    _createUserPanelTips() {

        this.add(() => $(".createTeamAssignmentsPanel  .radioSection .noAccessSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.no_access",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -430,
                offsetY: -20
            })


        this.add(() => $(".createTeamAssignmentsPanel  .radioSection .allSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.has_access_to_all_users",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -420,
                offsetY: -20
            })

        this.add(() => $(".createTeamAssignmentsPanel .radioSection .customSection"),
            {
                messageKey: "tips.account_and_permissions_tab.user_access_panel.has_access_to_selected_users",
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -380,
                offsetY: -20
            })

        this.add(() => $(".createUserAssignmentPanel .assignAllMenuButton.hierarchyClass_customer"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_customer_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".createUserAssignmentPanel .assignAllMenuButton.hierarchyClass_project"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_project_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".createUserAssignmentPanel .assignAllMenuButton.hierarchyClass_task"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.grant_access_tasks_checkbox",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -5
            })

        this.add(() => $(".createUserAssignmentPanel .breadcrumbContainer.customer .breadcrumb .closeIcon"),
            {
                messageKey: "tips.wa_ma_panel.upper_lvl_access",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -10,
                offsetY: 7,
            })

        this.add(() => $(".createUserAssignmentPanel .entitiesList").eqOrLast(0).find(".entityListItem.hierarchyClass_customer.assigned ").eqOrLast(0),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.assign_customers_highlighted",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -400,
                offsetY: -20
            })

        this.add(() => $(".createUserAssignmentPanel .entitiesList").eqOrLast(1).find(".entityListItem.hierarchyClass_project.assigned ").eqOrLast(0),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.assign_project_highlighted",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -400,
                offsetY: -20
            })

        this.add(() => $(".managementAssignmentsPanel .editAssignmentButton"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.ma_access_panel.edit_button",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -45,
                offsetY: 15
            })

        this.add(() => $(".managementAssignmentsPanel .counterTabPlaceholder .customerTab.active"),
            {
                messageKey: "tips.account_and_permissions_tab.ma_panel.ma_access_panel.tabs",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -90,
                offsetY: 8
            })
    }

    _addManageBalancesTips() {
        this.add(() => !this.state.isAnyUserListPanelOpen ? $(".showPTOSettings .userListRow .currentBalanceCell.ptoCell.on").eqOrLast(0) : $(),
            {
                messageKey: "tips.user_list.pto_balance",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -40,
                offsetY: 20
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ? $(".showPTOSettings .userListRow .plannedLeaveCell.ptoCell.on").eqOrLast(1) : $(),
            {
                messageKey: "tips.user_list.planned_leaves",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -65,
                offsetY: 15
            })

        this.add(() => {
            const element = !this.state.isAnyUserListPanelOpen ?
                            $(".showPTOSettings .userListRow").children(".ptoRulesCell.accrualRule, .ptoRulesCell.defaultRule")
                                                              .not(".noBalance").not(".defaultRules.accrualRule").eqOrLast(0) : $()
            return {
                element: element,
                config: {
                    messageKey: "tips.user_list.accrual",
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: element.hasClass("defaultRule") ? -115 : -30,
                    offsetY: 15
                }
            }
        })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".showPTOSettings .userListRow .ptoControlCell").eqOrLast(4) : $(),
            {
                messageKey: "tips.user_list.pto_toggle",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -30,
                offsetY: -5
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".showSickDaysSettings .userListRow .currentBalanceCell.sickDaysCell.on").eqOrLast(0) : $(),
            {
                messageKey: "tips.user_list.sick_days_balance",
                direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
                offsetX: -40,
                offsetY: 20
            })

        this.add(() => !this.state.isAnyUserListPanelOpen ?
                       $(".showSickDaysSettings .userListRow .plannedLeaveCell.sickDaysCell.on").eqOrLast(1) : $(),
            {
                messageKey: "tips.user_list.planned_leaves",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -65,
                offsetY: 15
            })

        this.add(() => {
            const element = !this.state.isAnyUserListPanelOpen ? $(".showSickDaysSettings .userListRow")
                .children(".sickDaysRulesCell.accrualRule, .sickDaysRulesCell.defaultRule")
                .not(".noBalance").not(".defaultRules.accrualRule").eqOrLast(0) : $()
            return {
                element: element,
                config: {
                    messageKey: "tips.user_list.accrual",
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: element.hasClass("defaultRule") ? -115 : -30,
                    offsetY: 15
                }
            }
        })

        this.add(() => !this.state.isAnyUserListPanelOpen ? $(".showSickDaysSettings .userListRow .sickDaysControlCell").eqOrLast(4) : $(),
            {
                messageKey: "tips.user_list.sick_toggle",
                direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                offsetX: -30,
                offsetY: -5
            })
    }
}

export default connect(
    state => ({
        isAnyUserListPanelOpen: isAnyUserListPanelOpen(state),
        isEditManagementAssignmentsEditorLoaded: isEditManagementAssignmentsEditorLoaded(state),
        isEditManagementAssignmentsPanelLoaded: isEditManagementAssignmentsPanelLoaded(state),
        isWorkAssignmentsPanelLoaded: isWorkAssignmentsPanelLoaded(state),
        isWorkAssignmentsEditorLoaded: isWorkAssignmentsEditorLoaded(state),
        isWorkAssignmentTabLoaded: isWorkAssignmentTabLoaded(state),
        areCustomersLoadedWork: areCustomersLoadedWork(state),
        areProjectsLoadedWork: areProjectsLoadedWork(state),
        areTasksLoadedWork: areTasksLoadedWork(state),
        isWorkAssignmentTabsLoaded: isWorkAssignmentTabsLoaded(state),
        areCustomersLoadedManagement: areCustomersLoadedManagement(state),
        areProjectsLoadedManagement: areProjectsLoadedManagement(state),
        areTasksLoadedManagement: areTasksLoadedManagement(state),
        canManagePtoAndSickDays: canManagePtoAndSickDays(state),
        canManageCustomerIds: getCanManageCustomerIds(state),
        canManageProjectIds: getCanManageProjectIds(state),
        canManageTaskIds: getCanManageTaskIds(state),
        managementAssignmentCounters: getManagementAssignmentsCounters(state),
    })
)(UserListPageOverlayTipsManager)



// WEBPACK FOOTER //
// ./web/js/tips/managers/UserListPageOverlayTipsManager.js